module.exports = __webpack_public_path__ + "static/media/icon.e689d74f.png";